/*
 * Which environment is the browser looking at.
 *
 * This is the QA feature-gate mechanic: content can ship to qa.physioactivity.com
 * and stay hidden on the live domain, so a page can be reviewed in place without
 * a branch or a second deploy.
 *
 * This is CLIENT-SIDE ONLY and must stay that way. The same host check inside an
 * Azure Function is unreliable — SWA managed functions do not dependably receive
 * the custom domain in host or x-forwarded-host, and an earlier attempt to gate
 * robots.txt this way evaluated production as non-production and served
 * "Disallow: /" on the live site, taking the whole domain out of Google
 * (fixed 2026-07-12). In the browser, window.location.hostname is exactly the
 * domain the visitor typed, so the check is sound here and nowhere else.
 *
 * Anything unrecognised counts as non-production: localhost, preview
 * environments and *.azurestaticapps.net all see the unreleased content, which
 * is the safe direction to fail. A gate that fails open on the live domain
 * would publish work that has not been signed off.
 */

const PRODUCTION_HOSTS = ['physioactivity.com', 'www.physioactivity.com'];

export function isProductionHost() {
    if (typeof window === 'undefined') return true;   // no window, assume live
    return PRODUCTION_HOSTS.includes(window.location.hostname.toLowerCase());
}

export default isProductionHost;
